<template>
  <v-container fluid>
    <v-row class="px-0 py-0 my-0">
      <v-col cols="3">
        <RangeFilter
            :end="dateEnd"
            :start="dateStart"
            @getDates="getDates"
            :excludePeriod="excludePeriod"
            :defaultPeriod="defaultPeriod"
            :setDates="true"
            :disabled="loadedCopper"
        />
      </v-col>
      <v-spacer></v-spacer>
      <last-time-updated :selectedDate="'updateCopper'" class=" mt-0 mt-md-4"/>
    </v-row>
    <v-card class="elevation-2 py-1 px-6 mt-4 rounded-lg">
      <v-row class="pa-0">
        <v-progress-linear indeterminate color="indigo" v-if="loadedCopper"></v-progress-linear>
        <v-col cols="12" md="6" :lg="12/statisticСards.length" class="d-flex justify-start justify-lg-center" v-for="(e, i) in statisticСards" :key="i">
          <div class="d-flex flex-column">
            <div class="d-flex align-end" v-for="(card, index) in statisticСards[i]" :key="index">
              <b class="pr-1">{{card.title}}: </b>
              <span v-if="!loadedCopper && card.filter === 'formatPrice'">${{ dataTotalsCopper[card.value] | formatPrice }}</span>
              <span v-if="!loadedCopper && card.filter === 'formatFloat'">{{ dataTotalsCopper[card.value] | formatFloat }}</span>
              <div v-if="showFilteredStatistic && card.filtered" class="text-caption primary--text ml-1"> {{ statisticFiltered[card.value] | formatFloat }}</div>
            
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="10" sm="5" class="pb-0">
          <v-text-field
            dense
            v-model="searchOpportunityCopper"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            outlined
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-btn
          color="indigo"
          class="mt-3"
          dark
          depressed
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFiltersOpportunityCopper"
        >
          <v-icon>
            mdi-autorenew
          </v-icon>
        </v-btn>
      </v-row>
      <v-row class="px-7 pb-0 pt-6">
        <v-col cols="12" md="6" lg="2" class="pa-0 mr-auto" v-for="(e, i) in autocompleteСards" :key="i">
          <v-autocomplete
            dense
            v-model="filtered[`${e.filtered}`]"
            :items="filters[`${e.filters}`]"
            :menu-props="{ maxHeight: '200' }"
            multiple
            outlined
            :class="['mr-md-1', {'v-input--is-focused primary--text' : filtered[`${e.filtered}`].length}]"
            @change="fetchFilters"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2" text-color="grey darken-4" class="grey lighten-3">
                <span >{{ item }}</span>
              </v-chip>
              <span
                v-if="index === 2"
                class="grey--text chip-counter"
              >
                (+{{ filtered[`${e.filtered}`].length - 2 }} {{ (filtered[`${e.filtered}`].length - 2) > 1 ? 'others' : 'another' }})
              </span>
              <v-chip text-color="white" :class="item.value" v-if="e.tooltip">
                <span>{{ item.text }}</span>
              </v-chip>
            </template>
            <template v-slot:label>
              <p :class="filtered[`${e.filtered}`].length ? 'primary--text' : ''">{{ e.name }}</p>
            </template>
            <template v-slot:item="{ active, item, on, attrs }" v-if="e.tooltip">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-row no-gutters align="center">
                      <span>{{ item.text }}</span>
                      <v-spacer></v-spacer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-on="on" v-bind="attrs" :color="item.value" small>mdi-information-outline</v-icon>
                        </template>
                        <span v-html="item.tooltip"></span>
                      </v-tooltip>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>      
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <v-row class="px-2 mt-5">
        <v-col cols="4" class="py-0 d-flex">
          <h2 class="pl-3">Quotes</h2>
        </v-col>
        <v-col cols="8" class="py-0 d-flex justify-end justify-md-end">
          <v-spacer></v-spacer>
          <vue-excel-xlsx
            :data="dataOpportunityCopperForExcel"
            :columns="columnsDataOpportunityCopper"
            :filename="`${settingsName}Opportunity`"
            :sheetname="`${dateStart} ~ ${dateEnd}`"
            >
              <v-btn
                height="39"           
                min-width="39px"        
                :disabled="dataOpportunityCopper.length === 0"
                class="ml-auto mr-5 rounded-lg px-0"                           
                color="white"
              >
                <ExportExcel />
              </v-btn> 
          </vue-excel-xlsx>
          <CustomColumns 
            :currentValue="valueOpportunityCopper"
            :currentCustomHeader="customHeaderOpportunityCopper"
            :currentHeaders="headersOpportunityCopper"
            :settingsName="`${settingsName}Opportunity`"
            @getCustomData="getCustomDataOpportunityCopper"
          />
        </v-col>
      </v-row>
      <v-hover v-model="hoverOnTableOpportunityCopper">
        <v-card-text>
          <div class="d-flex justify-space-between">        
            <v-btn
              class="mx-2 scroll-btn btn-left-arrow-cpr-opp"
              fab
              small     
              @click="scrollingLeftOpportunityCopper"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right-arrow-cpr-opp"
              fab
              small
              @click="scrollingRightOpportunityCopper"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 75, -1]
                }"
              :items-per-page="10"
              dense
              :headers="selectedHeadersOpportunityCopper"
              :items="dataFilteredOpportunityCopper"
              :page.sync="pagination.page"
              item-key="id"
              class="elevation-0 mt-2"
              :loading="loadedCopper"
              loading-text="Loading... Please wait"
              @click:row="rowClick"
              :search="searchOpportunityCopper"
          >
            <template v-slot:item.sale_at="{ item }">
              <span v-if="item.sale_at == '01/01/1900'">-</span>
               <span v-else>{{item.sale_at}}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
    <v-card class="elevation-2 pt-0 pb-5 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="10" sm="5" class="pb-0">
          <v-text-field
            dense
            v-model="searchLeadsToPeople"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            outlined
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-btn
          color="indigo"
          class="mt-3"
          dark
          depressed
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFiltersLeadsToPeople"
        >
          <v-icon>
            mdi-autorenew
          </v-icon>
        </v-btn>
      </v-row>
    </v-card> 
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <v-row class="px-2 mt-5">
        <v-col cols="4" class="py-0 d-flex">
          <h2 class="pl-3">Converted Leads to People</h2>
        </v-col>
        <v-col cols="8" class="py-0 d-flex justify-end justify-md-end">
          <v-spacer></v-spacer>
          <vue-excel-xlsx
            :data="dataLeadsToPeopleForExcel"
            :columns="columnsDataLeadsToPeople"
            :filename="`${settingsName}LeadsToPeople`"
            :sheetname="`${dateStart} ~ ${dateEnd}`"
            >
              <v-btn
                height="39"           
                min-width="39px"        
                :disabled="dataLeadsToPeople.length === 0"
                class="ml-auto mr-5 rounded-lg px-0"                           
                color="white"
              >
                <ExportExcel />
              </v-btn> 
          </vue-excel-xlsx>
          <CustomColumns 
            :currentValue="valueLeadsToPeople"
            :currentCustomHeader="customHeaderLeadsToPeople"
            :currentHeaders="headersLeadsToPeople"
            :settingsName="`${settingsName}LeadsToPeople`"
            @getCustomData="getCustomDataLeadsToPeople"
          />
        </v-col>
      </v-row>
      <v-hover v-model="hoverOnTableLeadsToPeople">
        <v-card-text>
          <div class="d-flex justify-space-between">        
            <v-btn
              class="mx-2 scroll-btn btn-left-arrow-cpr-ltp"
              fab
              small     
              @click="scrollingLeftLeadsToPeople"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right-arrow-cpr-ltp"
              fab
              small
              @click="scrollingRightLeadsToPeople"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 75, -1]
                }"
              :items-per-page="10"
              dense
              :headers="selectedHeadersLeadsToPeople"
              :items="dataLeadsToPeople"
              :page.sync="pagination.page"
              item-key="id"
              class="elevation-0 mt-2"
              :loading="loadedCopper"
              loading-text="Loading... Please wait"
              @click:row="rowClick"
              :search="searchLeadsToPeople"
          >
            <template v-slot:item.phone="{ item }">
              <span>{{ item.phone | formatPhone }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import RangeFilter from '@/components/filters/RangePicker'
import LastTimeUpdated from "@/views/LastTimeUpdated"
import CustomColumns from '@/components/customizing/CustomColumns'
import ExportExcel from '@/components/customizing/ExportExcel'

export default {
  components: {
    LastTimeUpdated,
    RangeFilter,
    CustomColumns,
    ExportExcel
  },
  data() {
    return {
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      pagination: {
        page: 1
      },
      paginationPotential: {
        page: 1
      },
      loadedCopper: false,
      dataLeadsToPeople: [],
      dataLeadsToPotential: [],
      dataCopper: [],
      dataOpportunityCopper: [],
      dataTotalsCopper: {
        createdOpenOpportunity: 0,
        createdOpportunity: 0,
        createdPeople: 0,
        leadToPeople: 0,
        openToWon: 0,
        converted: 0,
        potential: 0,
        totalValue: 0,
        totalGallons: 0,
        stillOpenOpportunity: 0
      },
      statisticFiltered: {
        potential: 0,
        converted: 0,
        totalValue: 0,
        totalGallons: 0
      },
      headersOpportunityCopper: [
        {text: 'Date of Creation', value: 'created_at', class: 'black--text'},
        {text: 'Date of Sale', value: 'sale_at', class: 'black--text'},
        {text: 'Name', value: 'op_name', class: 'black--text'},
        {text: 'Contact', value: 'contact', class: 'black--text'},
        {text: 'Company', value: 'company_name', class: 'black--text'},
        {text: 'Gallons', value: 'gallons', class: 'black--text'},
        {text: 'Value', value: 'price_value', class: 'black--text'},
        {text: 'Interactions', value: 'interactions', class: 'black--text'},
        {text: 'Inactivity days', value: 'inactive_days', class: 'black--text'},
        {text: 'Owner', value: 'owner', class: 'black--text'},
        {text: 'Status', value: 'status', class: 'black--text'},
        {text: 'Tags', value: 'tags', class: 'black--text'}
      ],
      valueOpportunityCopper: [
        {text: 'Date of Creation', value: 'created_at', class: 'black--text'},
        {text: 'Date of Sale', value: 'sale_at', class: 'black--text'},
        {text: 'Name', value: 'op_name', class: 'black--text'},
        {text: 'Contact', value: 'contact', class: 'black--text'},
        {text: 'Company', value: 'company_name', class: 'black--text'},
        {text: 'Gallons', value: 'gallons', class: 'black--text'},
        {text: 'Value', value: 'price_value', class: 'black--text'},
        {text: 'Interactions', value: 'interactions', class: 'black--text'},
        {text: 'Inactivity days', value: 'inactive_days', class: 'black--text'},
        {text: 'Owner', value: 'owner', class: 'black--text'},
        {text: 'Status', value: 'status', class: 'black--text'},
        {text: 'Tags', value: 'tags', class: 'black--text'}
      ],
      headersLeadsToPeople: [
        {text: 'Date of Creation', value: 'created_at', class: 'black--text'},
        {text: 'Date of Conversion', value: 'conversion_at', class: 'black--text'},
        {text: 'Full Name', value: 'full_name', class: 'black--text'},
        {text: 'Email', value: 'email', class: 'black--text'},
        {text: 'Phone', value: 'phone', class: 'black--text'},
        {text: 'Company', value: 'company_name', class: 'black--text'},
        {text: 'First Order Gallons', value: 'first_gallons', class: 'black--text'},
        {text: 'Tags', value: 'tags', class: 'black--text'},
        {text: 'Notes', value: 'notes', class: 'black--text'},
      ],
      headersLeadsToPotential: [
        {text: 'Date of Creation', value: 'created_at', class: 'black--text'},
        {text: 'Date of Conversion', value: 'conversion_at', class: 'black--text'},
        {text: 'Full Name', value: 'full_name', class: 'black--text'},
        {text: 'Email', value: 'email', class: 'black--text'},
        {text: 'Phone', value: 'phone', class: 'black--text'},
        {text: 'Company', value: 'company_name', class: 'black--text'},
      ],
      valueLeadsToPeople: [
        {text: 'Date of Creation', value: 'created_at', class: 'black--text'},
        {text: 'Date of Conversion', value: 'conversion_at', class: 'black--text'},
        {text: 'Full Name', value: 'full_name', class: 'black--text'},
        {text: 'Email', value: 'email', class: 'black--text'},
        {text: 'Phone', value: 'phone', class: 'black--text'},
        {text: 'Company', value: 'company_name', class: 'black--text'},
        {text: 'First Order Gallons', value: 'first_gallons', class: 'black--text'},
        {text: 'Tags', value: 'tags', class: 'black--text'},
      ],
      customHeaderLeadsToPeople: ['created_at', 'conversion_at', 'full_name', 'email',
                          'company_name', 'first_gallons', 'tags', 'notes'],
      customHeaderOpportunityCopper: ['created_at', 'op_name', 'contact', 'company_name',
                          'gallons', 'price_value', 'interactions', 'inactive_days',
                          'owner', 'status', 'tags', 'phone'],
      valueLeadsToPotential: [
        {text: 'Date of Creation', value: 'created_at', class: 'black--text'},
        {text: 'Date of Conversion', value: 'conversion_at', class: 'black--text'},
        {text: 'Full Name', value: 'full_name', class: 'black--text'},
        {text: 'Company', value: 'company_name', class: 'black--text'},
        {text: 'Email', value: 'email', class: 'black--text'},
        {text: 'Phone', value: 'phone', class: 'black--text'},
      ],
      customHeaderLeadsToPotential: ['created_at', 'conversion_at', 'full_name', 'email', 'phone', 'company_name'],
      selectedHeadersLeadsToPeople: [],
      selectedHeadersLeadsToPotential: [],
      selectedHeadersOpportunityCopper: [],
      settingsName: 'copperReport',
      columnsDataLeadsToPeople: [],
      columnsDataLeadsToPotential: [],
      columnsDataOpportunityCopper: [],
      hoverOnTableOpportunityCopper: false,
      hoverOnTableLeadsToPeople: false,
      hoverOnTableLeadsToPotential: false,
      statisticСards: [
        [
          {title: '# of created open quotes', value: 'createdQuotes', loaded: 'loadedCopper', filter: 'formatFloat'},
          {title: '# of open quotes', value: 'openQuotes', loaded: 'loadedCopper', filter: 'formatFloat'},
          {title: '# of converted quotes', value: 'convertedQuotes', loaded: 'loadedCopper', filter: 'formatFloat'},
        ],
        [
          {title: '# of lost quotes', value: 'lostQuotes', loaded: 'loadedCopper', filter: 'formatFloat'},
          {title: '# of abandoned quotes', value: 'abandonedQuotes', loaded: 'loadedCopper', filter: 'formatFloat'},
        ],
        [
          {title: '# converted leads to people', value: 'converted', loaded: 'loadedCopper', filter: 'formatFloat', filtered: true},
        ]
      ],
      filtered: {
        'status': [],
        'owner': [],
        'contact': [],
        'company_name': []
      },
      filters: {
        'status': [],
        'owner': [],
        'contact': [],
        'company_name': []        
      },
      autocompleteСards: [
        {name: 'Status Filter', filtered: 'status', filters: 'status'},
        {name: 'Owner Filter', filtered: 'owner', filters: 'owner'},
        {name: 'Contact Filter', filtered: 'contact', filters: 'contact'},
        {name: 'Company Filter', filtered: 'company_name', filters: 'company_name'},
      ],
      searchOpportunityCopper: '',
      searchLeadsToPeople: '',
      searchLeadsToPotential: ''
    }
  },
  watch: {
    valueLeadsToPeople(val) {
      this.selectedHeadersLeadsToPeople = val
      this.getHeaderForExcel()
    },
    valueOpportunityCopper(val) {
      this.selectedHeadersOpportunityCopper = val
      this.getHeaderForExcel()
    },
    hoverOnTableOpportunityCopper() {
      this.showScrollingArrowsOpportunityCopper()
    },
    hoverOnTableLeadsToPeople() {
      this.showScrollingArrowsLeadsToPeople()
    },
    hoverOnTableLeadsToPotential(){
       this.showScrollingArrowsLeadsToPotential()
    },
    searchOpportunityCopper(){
      let data = this.dataFilteredOpportunityCopper.filter(e => {
        let obj = Object.values(e).map(e => (e && typeof e != 'object') ? e.toString().toLowerCase() : '')
        return obj.some(i => i.match(this.searchOpportunityCopper.toLowerCase()))
      })
      this.statisticFiltered.totalGallons = data.reduce((acc, e) => acc + e.gallons, 0)
      this.statisticFiltered.totalValue = data.reduce((acc, e) => acc + e.price_value, 0)
    },
    searchLeadsToPeople(){
      let data = this.dataLeadsToPeople.filter(e => {
        let obj = Object.values(e).map(e => (e && typeof e != 'object') ? e.toString().toLowerCase() : '')
        return obj.some(i => i.match(this.searchLeadsToPeople.toLowerCase()))
      })
      this.statisticFiltered.converted = data.length
    },
    searchLeadsToPotential(){
      let data = this.dataLeadsToPotential.filter(e => {
        let obj = Object.values(e).map(e => (e && typeof e != 'object') ? e.toString().toLowerCase() : '')
        return obj.some(i => i.match(this.searchLeadsToPotential.toLowerCase()))
      })
      this.statisticFiltered.potential = data.length
    }
  },
  created() {
    this.selectedHeadersLeadsToPeople = this.valueLeadsToPeople
    this.selectedHeadersOpportunityCopper = this.valueOpportunityCopper
    this.selectedHeadersLeadsToPotential = this.valueLeadsToPotential
    this.getHeaderForExcel()
    window.addEventListener("resize", this.showScrollingArrowsOpportunityCopper)
    window.addEventListener("resize", this.showScrollingArrowsLeadsToPeople)
    window.addEventListener("resize", this.showScrollingArrowsLeadsToPotential)
  },
  destroyed() {
    window.removeEventListener("resize", this.showScrollingArrowsOpportunityCopper)
    window.removeEventListener("resize", this.showScrollingArrowsLeadsToPeople)
  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }

    if (localStorage.getItem('crmReport')) {
      let data = JSON.parse(localStorage.getItem('crmReport'))
      this.dateStart = data.dateStart
      this.dateEnd = data.dateEnd
      this.defaultPeriod = data.defaultPeriod
      localStorage.removeItem('crmReport')
    }

    this.applyFilters()

    let userName = localStorage.getItem('username')
    let settings = this.settingsName
    let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1

    if (localStorage.getItem(`${userName}.${clientId}.${settings}Opportunity`)) {
      try {           
        let valueOpportunityCopperCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}Opportunity`))
        this.valueOpportunityCopper = valueOpportunityCopperCash.filter(e => this.headersOpportunityCopper.find(item => item.value === e.value))
        
        const parsed = JSON.stringify(this.valueOpportunityCopper)
        localStorage.setItem(`${userName}.${clientId}.${settings}Opportunity`, parsed)


        this.customHeaderOpportunityCopper = this.valueOpportunityCopper.map(e => e.value)
      } catch(e) {
        console.log("")
      }
    }

    if (localStorage.getItem(`${userName}.${clientId}.${settings}LeadsToPeople`)) {
      try {           
        let valueLeadsToPeopleCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}LeadsToPeople`))
        this.valueLeadsToPeople = valueLeadsToPeopleCash.filter(e => this.headersLeadsToPeople.find(item => item.value === e.value))
        
        const parsed = JSON.stringify(this.valueLeadsToPeople)
        localStorage.setItem(`${userName}.${clientId}.${settings}LeadsToPeople`, parsed)


        this.customHeaderLeadsToPeople = this.valueLeadsToPeople.map(e => e.value)
      } catch(e) {
        console.log("")
      }
    }

    this.showScrollingArrowsOpportunityCopper()
    this.showScrollingArrowsLeadsToPeople()
  },
  computed: {
    dataOpportunityCopperForExcel() {
      if (!this.dataFilteredOpportunityCopper) return []
      return JSON.parse(JSON.stringify(this.dataOpportunityCopper))
    },
    dataLeadsToPeopleForExcel() {
      if (!this.dataLeadsToPeople) return []
      return JSON.parse(JSON.stringify(this.dataLeadsToPeople))
    },
    dataLeadsToPotentialForExcel() {
      if (!this.dataLeadsToPotential) return []
      return JSON.parse(JSON.stringify(this.dataLeadsToPotential))
    },
    dataFilteredOpportunityCopper() {
      return this.dataOpportunityCopper.filter(d => {
        return Object.keys(this.filtered).every(f => {
          if(Array.isArray(d[f])){ // custom filter
            let names = this._.map(d[f], p => {return p.name})
            for (let n of names){
              if (this.filtered[f].includes(n)){
                return this.filtered[f].length < 1 || this.filtered[f].includes(n)
              }
            }
          }
          return this.filtered[f].length < 1 || this.filtered[f].includes(d[f])
        })
      })
    },
    showFilteredStatistic(){
      return Object.values(this.filtered).some(e => e.length) || this.searchOpportunityCopper.length || this.searchLeadsToPeople.length
    }
  },
  methods: {
    scrollingRightOpportunityCopper() {
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[0].scrollLeft = el[0].scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow-cpr-opp')
      const btnLeft = document.querySelector('.btn-left-arrow-cpr-opp')
      btnRight.style.visibility = (this.hoverOnTableOpportunityCopper && (el[0].scrollLeft + el[0].clientWidth != el[0].scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTableOpportunityCopper ? 'visible' : 'hidden'
    },
    scrollingLeftOpportunityCopper() {
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[0].scrollLeft = el[0].scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow-cpr-opp')
      const btnRight = document.querySelector('.btn-right-arrow-cpr-opp')
      btnLeft.style.visibility = (this.hoverOnTableOpportunityCopper && (el[0].scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTableOpportunityCopper ? 'visible' : 'hidden'
    },
    showScrollingArrowsOpportunityCopper() {
      const el = document.querySelectorAll('.v-data-table__wrapper')

      const btnRightOpportunityCopper = document.querySelector('.btn-right-arrow-cpr-opp')
      const btnLeftOpportunityCopper = document.querySelector('.btn-left-arrow-cpr-opp')
      btnRightOpportunityCopper.style.visibility = (this.hoverOnTableOpportunityCopper && (el[0].scrollLeft + el[0].clientWidth !== el[0].scrollWidth)) ? 'visible' : 'hidden'
      btnLeftOpportunityCopper.style.visibility = (this.hoverOnTableOpportunityCopper && (el[0].scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    scrollingRightLeadsToPeople() {
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[1].scrollLeft = el[1].scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow-cpr-ltp')
      const btnLeft = document.querySelector('.btn-left-arrow-cpr-ltp')
      btnRight.style.visibility = (this.hoverOnTableLeadsToPeople && (el[0].scrollLeft + el[0].clientWidth != el[0].scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTableLeadsToPeople ? 'visible' : 'hidden'
    },
    scrollingLeftLeadsToPeople() {
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[1].scrollLeft = el[1].scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow-cpr-ltp')
      const btnRight = document.querySelector('.btn-right-arrow-cpr-ltp')
      btnLeft.style.visibility = (this.hoverOnTableLeadsToPeople && (el[1].scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTableLeadsToPeople ? 'visible' : 'hidden'
    },
    showScrollingArrowsLeadsToPeople() {
      const el = document.querySelectorAll('.v-data-table__wrapper')

      const btnRightLeadsToPeople = document.querySelector('.btn-right-arrow-cpr-ltp')
      const btnLeftLeadsToPeople = document.querySelector('.btn-left-arrow-cpr-ltp')
      btnRightLeadsToPeople.style.visibility = (this.hoverOnTableLeadsToPeople && (el[1].scrollLeft + el[1].clientWidth !== el[1].scrollWidth)) ? 'visible' : 'hidden'
      btnLeftLeadsToPeople.style.visibility = (this.hoverOnTableLeadsToPeople && (el[1].scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    scrollingRightLeadsToPotential() {
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[1].scrollLeft = el[1].scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow-cpr-ltp')
      const btnLeft = document.querySelector('.btn-left-arrow-cpr-ltp')
      btnRight.style.visibility = (this.hoverOnTableLeadsToPotential && (el[0].scrollLeft + el[0].clientWidth != el[0].scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTableLeadsToPotential ? 'visible' : 'hidden'
    },
    scrollingLeftLeadsToPotential() {
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[1].scrollLeft = el[1].scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow-cpr-ltp')
      const btnRight = document.querySelector('.btn-right-arrow-cpr-ltp')
      btnLeft.style.visibility = (this.hoverOnTableLeadsToPotential && (el[1].scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTableLeadsToPotential ? 'visible' : 'hidden'
    },
    showScrollingArrowsLeadsToPotential() {
      const el = document.querySelectorAll('.v-data-table__wrapper')

      const btnRightLeadsToPeople = document.querySelector('.btn-right-arrow-cpr-ltp')
      const btnLeftLeadsToPeople = document.querySelector('.btn-left-arrow-cpr-ltp')
      btnRightLeadsToPeople.style.visibility = (this.hoverOnTableLeadsToPotential && (el[1].scrollLeft + el[1].clientWidth !== el[1].scrollWidth)) ? 'visible' : 'hidden'
      btnLeftLeadsToPeople.style.visibility = (this.hoverOnTableLeadsToPotential && (el[1].scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.applyFilters()
    },
    applyFilters() {
      this.loadedCopper = true
      axios
          .get('/reports/copper/' + this.dateStart + '/' + this.dateEnd)
          .then(response => {

            this.dataLeadsToPeople = response.data.leads_to_people
            this.dataLeadsToPotential = response.data.leads_to_potential
            this.dataOpportunityCopper = response.data.opportunity

            //this.dataTotalsCopper.createdPeople = this._.sumBy(this.dataCopper, 'created_people')

            this.dataTotalsCopper.createdQuotes = this.dataOpportunityCopper.filter(e=>e.status !== "Won").length
            this.dataTotalsCopper.wonQuotes = this.dataOpportunityCopper.filter(e=>e.status === "Won").length
            this.dataTotalsCopper.openQuotes = this.dataOpportunityCopper.filter(e=>e.status === "Open").length
            this.dataTotalsCopper.convertedQuotes = this.dataOpportunityCopper.filter(e=>e.status === "Converted").length
            this.dataTotalsCopper.lostQuotes = this.dataOpportunityCopper.filter(e=>e.status === "Lost").length
            this.dataTotalsCopper.abandonedQuotes = this.dataOpportunityCopper.filter(e=>e.status === "Abandoned").length

            this.dataTotalsCopper.converted = this.dataLeadsToPeople.length
            this.dataTotalsCopper.potential = this.dataLeadsToPotential.length

            this.dataOpportunityCopper = this.dataOpportunityCopper.filter(e=>e.status !== "Won")

            this.fetchFilters()
            this.loadedCopper = false
          })
    },
    fetchFilters() {
      this.filters.status = this._.compact(this.dataOpportunityCopper
              .map(e => e.status)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.filters.owner = this._.compact(this.dataOpportunityCopper
              .map(e => e.owner)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.filters.contact = this._.compact(this.dataOpportunityCopper
              .map(e => e.contact)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.filters.company_name = this._.compact(this.dataOpportunityCopper
              .map(e => e.company_name)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.statisticFiltered.totalGallons = this.dataFilteredOpportunityCopper.reduce((acc, e) => acc+e.gallons, 0)
      this.statisticFiltered.totalValue = this.dataFilteredOpportunityCopper.reduce((acc, e) => acc+e.price_value, 0)
      this.statisticFiltered.converted = this.dataLeadsToPeople.length
      this.statisticFiltered.potential = this.dataLeadsToPotential.length
    },
    cleanFiltersOpportunityCopper(){
      this.searchOpportunityCopper = ''

      this.filtered.status = []
      this.filtered.owner = []
      this.filtered.contact = []
      this.filtered.company_name = []
    },
    cleanFiltersLeadsToPeople(){
      this.searchLeadsToPeople = ''
    },
    cleanFiltersLeadsToPotential(){
      this.searchLeadsToPotential = ''
    },
    rowClick: function (item, row) {
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
    getCustomDataOpportunityCopper({customHeader, value, selectedHeaders}){
      this.customHeaderOpportunityCopper = customHeader
      this.valueOpportunityCopper = value
      this.selectedHeadersOpportunityCopper = selectedHeaders
    },
    getCustomDataLeadsToPeople({customHeader, value, selectedHeaders}){
      this.customHeaderLeadsToPeople = customHeader
      this.valueLeadsToPeople = value
      this.selectedHeadersLeadsToPeople = selectedHeaders
    },
    getCustomDataLeadsToPotential({customHeader, value, selectedHeaders}){
      this.customHeaderLeadsToPotential = customHeader
      this.valueLeadsToPotential = value
      this.selectedHeadersLeadsToPotential = selectedHeaders
    },
    getHeaderForExcel(){
      this.columnsDataOpportunityCopper = this.selectedHeadersOpportunityCopper.map(e => {
        const obj = {}
        if (e.value !== "actions") {
          obj.label = e.text
          obj.field = e.value
        }
        return obj
      })

      this.columnsDataLeadsToPeople = this.selectedHeadersLeadsToPeople.map(e => {
        const obj = {}
        if (e.value !== "actions") {
          obj.label = e.text
          obj.field = e.value
        }
        return obj
      })

      this.columnsDataLeadsToPotential = this.selectedHeadersLeadsToPotential.map(e => {
        const obj = {}
        if (e.value !== "actions") {
          obj.label = e.text
          obj.field = e.value
        }
        return obj
      })
    },
  }
}
</script>


<style scoped>
  .btn-right-arrow-cpr-opp,
  .btn-right-arrow-cpr-ltp {
    right: 0px;
    top: 65px;
  }
  .btn-left-arrow-cpr-opp,
  .btn-left-arrow-cpr-ltp {
    left: 0px;
    top: 65px;
  }
.v-application .text-caption {
  line-height: 1.5rem;
}
</style>